import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '@/admin/views/Home.vue';
import DashboardEditor from '@/admin/views/DashboardEditor.vue';
import UserManagement from '@/admin/views/UserManagement.vue';
import ThemeEditor from '@/admin/views/ThemeEditor.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Dashboards',
    component: Home,
    icon: 'mdi-monitor-dashboard',
  },
  {
    path: '/user',
    name: 'Users',
    component: UserManagement,
    icon: 'mdi-account',
  },
  {
    path: '/themes',
    name: 'Themes',
    component: ThemeEditor,
    icon: 'mdi-compare',
  },
  {
    path: '/dashboard_editor/:id',
    name: 'DashboardEditor',
    component: DashboardEditor,
    hideInMenu: true,
  },
  {
    path: '*',
    name: 'Dashboards',
    component: Home,
    icon: 'mdi-monitor-dashboard',
    hideInMenu: true,
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
